// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"kHTXX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Export the mask because it's used by default inside the carousel.
 */ parcelHelpers.export(exports, "Mask", ()=>(0, _mask.Mask));
/**
 * The carousel instance.
 */ parcelHelpers.export(exports, "Carousel", ()=>Carousel);
var _mask = require("./features/mask");
var _proxy = require("./proxy");
var _types = require("./types");
var _cache = require("./utils/cache");
var _debounce = require("./utils/debounce");
const ID_NAME = (count)=>`caroucssel-${count}`;
const ID_MATCH = /^caroucssel-[0-9]*$/;
const EVENT_SCROLL = 'scroll';
const EVENT_RESIZE = 'resize';
const CACHE_KEY_ELEMENT = 'element';
const CACHE_KEY_ID = 'id';
const CACHE_KEY_CONFIGURATION = 'config';
const CACHE_KEY_INDEX = 'index';
const CACHE_KEY_ITEMS = 'items';
const CACHE_KEY_PAGES = 'pages';
const CACHE_KEY_PAGE_INDEX = 'page-index';
const CACHE_KEY_MASK = 'mask';
const CACHE_KEY_PROXY = 'proxy';
const CACHE_KEY_FEATURES = 'feautres';
const VISIBILITY_OFFSET = 0.25;
const INVISIBLE_ELEMENTS = /^(link|meta|noscript|script|style|title)$/i;
/*
 * Internal counter for created instances. Will be used to create unique IDs.
 */ let __instanceCount = 0;
const DEFAULTS = {
    features: [],
    filterItem: ()=>true,
    onScroll: ()=>undefined
};
class Carousel {
    /**
     * This will be used for testing purposes to reset the instance count which is
     * used to create unique id's.
     * @internal
     */ static resetInstanceCount() {}
    /**
     * Creates an instance.
     * @param el is the dom element to control. This should be a container element
     * 	that holds child elements that will scroll horizontally.
     * @param options are the options to configure this instance.
     */ constructor(el, options = {}){
        /**
         * Current scroll behavior. Possible values are:
         * * `'auto'`
         * * `'smooth'`
         */ this.behavior = (0, _types.ScrollBehavior).AUTO;
        if (!el || !(el instanceof Element)) throw new Error(`Carousel needs a dom element but "${typeof el}" was passed.`);
        (0, _cache.writeCache)(this, CACHE_KEY_ELEMENT, el);
        // Count all created instances to create unique id, if given dom element
        // has no id-attribute:
        __instanceCount++;
        el.id = el.id || ID_NAME(__instanceCount);
        (0, _cache.writeCache)(this, CACHE_KEY_ID, el.id);
        // Extend options and defaults into configuration:
        const configuration = Object.assign(Object.assign({}, DEFAULTS), options);
        (0, _cache.writeCache)(this, CACHE_KEY_CONFIGURATION, configuration);
        // Detect if there is a "Mask" feature passed as option. Then use this one,
        // otherwise add a mandatory instance by default. Also ensure that only one
        // feature of type "Mask" is in the features list.
        let mask = null;
        let features = [
            ...configuration.features
        ];
        const index = configuration.features.findIndex((feature)=>feature instanceof (0, _mask.Mask));
        if (index > -1) // Extract first found instance of "Mask":
        [mask] = features.splice(index, 1);
        mask !== null && mask !== void 0 ? mask : mask = new (0, _mask.Mask)();
        features = features.filter((feature)=>!(feature instanceof (0, _mask.Mask)));
        features = [
            mask,
            ...features
        ];
        (0, _cache.writeCache)(this, CACHE_KEY_MASK, mask);
        // Features: Initialize all features with a single proxy instance inbetween.
        const proxy = new (0, _proxy.Proxy)(this, features);
        (0, _cache.writeCache)(this, CACHE_KEY_PROXY, proxy);
        (0, _cache.writeCache)(this, CACHE_KEY_FEATURES, features);
        features.forEach((feature)=>feature.init(proxy));
        // Set initial index and finally set smooth scrolling to enabled:
        switch(true){
            // When index is a list:
            case Array.isArray(options.index):
                this.index = options.index;
                break;
            // When index is a number, transfrom to list:
            case !isNaN(options.index):
                this.index = [
                    options.index
                ];
                break;
        }
        this.behavior = (0, _types.ScrollBehavior).SMOOTH;
        // Debounced events:
        //
        // Where do these magic numbers come from? The numbers are the results of
        // testing the behavior in several browsers and are considered at "best fit"
        // without visible side effects to the UI. The value for the "scroll" event
        // correlates with the timing of scroll-behaviour: smooth.
        //
        // We disable @typescript-eslint/unbound-method here because we already bound
        // the functions while creating a debounced version. This would also cause
        // reference errors when tying to access these function references when used
        // with removeEventListeners() (see: destroy())
        //
        /* eslint-disable @typescript-eslint/unbound-method */ this._onScroll = (0, _debounce.debounce)(this._onScroll.bind(this), 45);
        this._onResize = (0, _debounce.debounce)(this._onResize.bind(this), 25);
        el.addEventListener(EVENT_SCROLL, this._onScroll);
        window.addEventListener(EVENT_RESIZE, this._onResize);
    /* eslint-enable @typescript-eslint/unbound-method */ }
    /**
     * Returns the dom element reference of the carousel which was passed into the
     * constructor.
     * @public
     * @return the controlled dom element
     */ get el() {
        return (0, _cache.fromCache)(this, CACHE_KEY_ELEMENT);
    }
    /**
     * Returns the dom element reference of the mask element that wraps the
     * carousel element.
     * @public
     * @return the mask dom element
     */ get mask() {
        var _a;
        const mask = (0, _cache.fromCache)(this, CACHE_KEY_MASK);
        return (_a = mask.el) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * Returns the id-attribute value of the carousel.
     * @public
     * @return the id of the controlled dom element
     */ get id() {
        return (0, _cache.fromCache)(this, CACHE_KEY_ID);
    }
    /**
     * Returns the current index of the carousel. The returned index is a list (array)
     * of indexes that are currently visible (depending on each item width).
     * @public
     * @return a list of visible indexes
     */ get index() {
        return (0, _cache.fromCache)(this, CACHE_KEY_INDEX, ()=>{
            const { el, items } = this;
            const { length } = items;
            const { clientWidth } = el;
            const outerLeft = el.getBoundingClientRect().left;
            const index = [];
            let at = 0;
            for(; at < length; at++){
                const item = items[at];
                const rect = item.getBoundingClientRect();
                const { width } = rect;
                let { left } = rect;
                left = left - outerLeft;
                if (left + width * VISIBILITY_OFFSET >= 0 && left + width * (1 - VISIBILITY_OFFSET) <= clientWidth) index.push(at);
            }
            if (index.length === 0) // If no index found, we return a [0] as default. This possibly happens
            // when the carousel is not attached to the DOM or is visually hidden (display: none).
            return [
                0
            ];
            return index;
        });
    }
    /**
     * Sets the current index of the carousel. To set an index you need to pass an
     * array with at least one element. When passing more than one, the rest will
     * be ignored.
     * @public
     * @param values are the upcoming indexes
     */ set index(values) {
        const { behavior, el, items } = this;
        const { length } = items;
        if (!Array.isArray(values) || !values.length) return;
        let value = values[0] || 0;
        value = Math.max(Math.min(value, length - 1), 0);
        const { scrollLeft } = el;
        const from = {
            left: scrollLeft
        };
        const to = {
            left: items[value].offsetLeft
        };
        // If the target item is the first visible element in the list, ignore
        // the possible offset to the left and scroll to the beginning of the list:
        if (value === this.pages[0][0]) to.left = 0;
        if (from.left === to.left) return;
        (0, _cache.clearCache)(this, CACHE_KEY_INDEX);
        el.scrollTo(Object.assign(Object.assign({}, to), {
            behavior
        }));
    }
    /**
     * Returns an array of all child dom elements of the carousel.
     * @public
     * @return a list of elements (child elements of the root element)
     */ get items() {
        return (0, _cache.fromCache)(this, CACHE_KEY_ITEMS, ()=>{
            const { filterItem } = (0, _cache.fromCache)(this, CACHE_KEY_CONFIGURATION);
            const { el } = this;
            const children = Array.from(el.children);
            return children.filter((item)=>!INVISIBLE_ELEMENTS.test(item.tagName) && !item.hidden).filter(filterItem);
        });
    }
    /**
     * Returns an array of all pages. Each page is a group of indexes that matches
     * a page.
     * @public
     * @return the list of pages and indexes inside each page
     */ get pages() {
        return (0, _cache.fromCache)(this, CACHE_KEY_PAGES, ()=>{
            const { el, items } = this;
            const { clientWidth: viewport } = el;
            if (viewport === 0) // if the width of the carousel element is zero, we can not calculate
            // the pages properly and the carousel seems to be not visible. If
            // this is the case, we assume that each item is placed on a
            // separate page.
            return items.map((item, index)=>[
                    index
                ]);
            let pages = [
                []
            ];
            items.map((item, index)=>{
                // Create a re-usable dataset for each item:
                const { offsetLeft: left, clientWidth: width } = item;
                return {
                    left,
                    width,
                    item,
                    index
                };
            }).sort((a, b)=>{
                // Create ordered list of items based on their visual ordering.
                // This may differ from the DOM ordering unsing css properties
                // like `order` in  flexbox or grid:
                return a.left - b.left;
            }).forEach((item)=>{
                // Calculate pages / page indexes for each item:
                //
                // The idea behind the calculation of the pages is to separate
                // the items by fitting them into the viewport of the carousel.
                // To behave correctly, we cannot divide the total length of the
                // carousel by the viewport to get the page indexes (naive approach).
                // However, since there may be items that are partially visible
                // on a page, but mathematically create a new page. The calculation
                // must start from this item again. This means that always the
                // first item on a page sets the basis for the calculation of
                // the following item and its belonging to the current or next
                // page:
                const { left, width } = item;
                const prevPage = pages[pages.length - 1];
                const firstItem = prevPage[0];
                let start = (firstItem === null || firstItem === void 0 ? void 0 : firstItem.left) || 0;
                // This is required for the first page. The first page always
                // needs to start from the left=0. Any offset from the
                // left of the first visual item needs to be ignored, otherwise
                // the calculation of visual pages is incorrect:
                if (prevPage === pages[0]) start = 0;
                // At least 75% of the items needs to be in the page. Calculate
                // the amount of new pages to add. If value is 0, the current
                // item fits into the previous page:
                let add = Math.floor((left - start + width * (1 - VISIBILITY_OFFSET)) / viewport);
                while(add > 0){
                    pages.push([]);
                    add--;
                }
                const page = pages[pages.length - 1];
                page.push(item);
            });
            // Remove empty pages: this might happen if items are wider than the
            // carousel viewport:
            pages = pages.filter((page)=>page.length !== 0);
            // Restructure pages to only contain the index of each item:
            return pages.map((page)=>page.map(({ index })=>index));
        });
    }
    /**
     * Returns the index of the current page.
     * @public
     * @return the index of the current page
     */ get pageIndex() {
        return (0, _cache.fromCache)(this, CACHE_KEY_PAGE_INDEX, ()=>{
            const { el, items, index, pages } = this;
            const outerLeft = el.getBoundingClientRect().left;
            const { clientWidth } = el;
            let visibles = index.reduce((acc, at)=>{
                if (!items[at]) return acc;
                let { left, right } = items[at].getBoundingClientRect();
                // "getBoundingClientRect()" can return float numbers which
                // lead to an unwanted behavior when in the calculation with
                // "clientWidth" (not using floats). We use round here to
                // normalize those values...
                left = Math.round(left - outerLeft);
                right = Math.round(right - outerLeft);
                // Remove items that partially hidden to the left or right:
                if (left < 0 || clientWidth < right) return acc;
                return acc.concat([
                    at
                ]);
            }, []);
            // There might be no possible candidates. This is the case when items
            // are wider than the element viewport. In this case we take the first
            // item which is currently visible in general (might be the only one):
            if (visibles.length === 0) visibles = [
                index[0]
            ];
            // Search for the visible item that is most aligned to the right. The
            // found item marks the current page...
            const at = visibles.sort((a, b)=>{
                const rightA = items[a].getBoundingClientRect().right;
                const rightB = items[b].getBoundingClientRect().right;
                return rightB - rightA;
            })[0];
            // Find the page index where the current item index is located...
            return pages.findIndex((page)=>page.includes(at));
        });
    }
    /**
     * This completely deconstructs the carousel and returns the dom to its
     * initial state.
     * @public
     */ destroy() {
        const { el } = this;
        // Remove created id if it was created by carousel:
        ID_MATCH.test(el.id) && el.removeAttribute('id');
        // Destroy attached features:
        const features = (0, _cache.fromCache)(this, CACHE_KEY_FEATURES);
        features.forEach((feature)=>feature.destroy());
        // Remove events:
        //
        // We need to work the the function reference. Using .bind() would create a
        // new referenced instance of the callback function. We already created a
        // bound version of these function within the constructor.
        //
        /* eslint-disable @typescript-eslint/unbound-method */ el.removeEventListener(EVENT_SCROLL, this._onScroll);
        window.removeEventListener(EVENT_RESIZE, this._onResize);
        /* eslint-enable @typescript-eslint/unbound-method */ // Clear cache:
        (0, _cache.clearFullCache)(this);
    }
    /**
     * Enforces an update of all enabled components of the carousel. This is, for
     * example, useful when changing the number of items inside the carousel. This
     * also forwards an update call to all attached features.
     * @public
     */ update() {
        (0, _cache.clearCache)(this, CACHE_KEY_INDEX);
        (0, _cache.clearCache)(this, CACHE_KEY_ITEMS);
        (0, _cache.clearCache)(this, CACHE_KEY_PAGES);
        (0, _cache.clearCache)(this, CACHE_KEY_PAGE_INDEX);
        const features = (0, _cache.fromCache)(this, CACHE_KEY_FEATURES);
        features.forEach((feature)=>feature.update({
                type: (0, _types.UpdateType).FORCED
            }));
    }
    _onScroll(event) {
        (0, _cache.clearCache)(this, CACHE_KEY_INDEX);
        (0, _cache.clearCache)(this, CACHE_KEY_PAGE_INDEX);
        const features = (0, _cache.fromCache)(this, CACHE_KEY_FEATURES);
        features.forEach((feature)=>feature.update({
                type: (0, _types.UpdateType).SCROLL
            }));
        const { index } = this;
        const configuration = (0, _cache.fromCache)(this, CACHE_KEY_CONFIGURATION);
        configuration.onScroll({
            index,
            type: EVENT_SCROLL,
            target: this,
            originalEvent: event
        });
    }
    _onResize() {
        (0, _cache.clearCache)(this, CACHE_KEY_PAGES);
        (0, _cache.clearCache)(this, CACHE_KEY_INDEX);
        (0, _cache.clearCache)(this, CACHE_KEY_PAGE_INDEX);
        const features = (0, _cache.fromCache)(this, CACHE_KEY_FEATURES);
        features.forEach((feature)=>feature.update({
                type: (0, _types.UpdateType).RESIZE
            }));
    }
}

},{"./features/mask":"eu1Ki","./proxy":"cDUpB","./types":"cpTwZ","./utils/cache":"awvb8","./utils/debounce":"kr3u0","@parcel/transformer-js/src/esmodule-helpers.js":"i3RlB"}],"eu1Ki":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The feature to enable/disabled mask and scrollbar support. This feature will
 * be added by default to each carousel. Use this feature to customize the
 * default behaviour.
 */ parcelHelpers.export(exports, "Mask", ()=>Mask);
var _types = require("../../types");
var _cache = require("../../utils/cache");
var _scrollbar = require("./scrollbar");
const FEATURE_NAME = 'buildin:mask';
const CACHE_KEY_PROXY = 'prxy';
const CACHE_KEY_CONFIGURATION = 'conf';
const CACHE_KEY_MASK = 'mask';
const CACHE_KEY_HEIGHT = 'hght';
/**
 * Singleton of scrollbar util. Is shared across all instances of carousel to
 * reduce redundant calculations.
 * @internal
 */ let __scrollbar;
const DEFAULTS = {
    enabled: true,
    className: 'caroucssel-mask',
    tagName: 'div'
};
class Mask {
    /**
     * Creates an instance of this feature.
     * @param options are the options to configure this instance
     */ constructor(options = {}){
        (0, _cache.writeCache)(this, CACHE_KEY_CONFIGURATION, Object.assign(Object.assign({}, DEFAULTS), options));
    }
    /**
     * Returns the name of this feature.
     */ get name() {
        return FEATURE_NAME;
    }
    /**
     * Returns the rendered element that wraps the carousel. If not enabled, this
     * returns `null`.
     * @return the mask element, otherwise `null` if disabled.
     */ get el() {
        var _a;
        return (_a = (0, _cache.fromCache)(this, CACHE_KEY_MASK)) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * Initializes this feature. This function will be called by the carousel
     * instance and should not be called manually.
     * @internal
     * @param proxy the proxy instance between carousel and feature
     */ init(proxy) {
        (0, _cache.writeCache)(this, CACHE_KEY_PROXY, proxy);
        // Create a singleton instance of scrollbar for all carousel instances:
        __scrollbar = __scrollbar !== null && __scrollbar !== void 0 ? __scrollbar : new (0, _scrollbar.Scrollbar)();
        this._render();
    }
    /**
     * Destroys this feature. This function will be called by the carousel instance
     * and should not be called manually.
     * @internal
     */ destroy() {
        this._remove();
        (0, _cache.clearFullCache)(this);
    }
    /**
     * This triggers the feature to update its inner state. This function will be
     * called by the carousel instance and should not be called manually. The
     * carousel passes a event object that includes the update reason. This can be
     * used to selectively/partially update sections of the feature.
     * @internal
     * @param event event that triggered the update
     * @param event.reason is the update reason (why this was triggered)
     */ update(event) {
        switch(event.type){
            case (0, _types.UpdateType).RESIZE:
            case (0, _types.UpdateType).FORCED:
                (0, _cache.clearCache)(this, CACHE_KEY_HEIGHT);
                this._render();
                break;
            default:
                this._render();
                break;
        }
    }
    /**
     * Renders the mask element, wraps the carousel element and crops the
     * height of the browsers scrollbar.
     * @internal
     */ _render() {
        const { enabled, className, tagName } = (0, _cache.fromCache)(this, CACHE_KEY_CONFIGURATION);
        if (!enabled) return;
        const proxy = (0, _cache.fromCache)(this, CACHE_KEY_PROXY);
        const element = proxy.el;
        let { height } = __scrollbar.dimensions;
        if (element.scrollWidth <= element.clientWidth) // If the contents are not scrollable because their width are less
        // than the container, there will be no visible scrollbar. In this
        // case, the scrollbar height is 0:
        height = 0;
        // Use fromCache factory to render mask element only once:
        (0, _cache.fromCache)(this, CACHE_KEY_MASK, ()=>{
            var _a;
            const mask = document.createElement(tagName);
            mask.className = className;
            mask.style.overflow = 'hidden';
            mask.style.height = '100%';
            (_a = element.parentNode) === null || _a === void 0 || _a.insertBefore(mask, element);
            mask.appendChild(element);
            return mask;
        });
        const cachedHeight = (0, _cache.fromCache)(this, CACHE_KEY_HEIGHT);
        if (height === cachedHeight) return;
        (0, _cache.writeCache)(this, CACHE_KEY_HEIGHT, height);
        element.style.height = `calc(100% + ${height}px)`;
        element.style.marginBottom = `${height * -1}px`;
    }
    /**
     * Removes the mask element and unwraps the carousel element.
     * @internal
     */ _remove() {
        var _a, _b;
        const { el } = (0, _cache.fromCache)(this, CACHE_KEY_PROXY);
        const mask = (0, _cache.fromCache)(this, CACHE_KEY_MASK);
        (_a = mask === null || mask === void 0 ? void 0 : mask.parentNode) === null || _a === void 0 || _a.insertBefore(el, mask);
        (_b = mask === null || mask === void 0 ? void 0 : mask.parentNode) === null || _b === void 0 || _b.removeChild(mask);
        el.removeAttribute('style');
    }
}

},{"../../types":"cpTwZ","../../utils/cache":"awvb8","./scrollbar":"ei8Rc","@parcel/transformer-js/src/esmodule-helpers.js":"i3RlB"}],"cpTwZ":[function(require,module,exports,__globalThis) {
/**
 * Possible types of an update.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UpdateType", ()=>UpdateType);
parcelHelpers.export(exports, "ScrollBehavior", ()=>ScrollBehavior);
var UpdateType;
(function(UpdateType) {
    UpdateType["SCROLL"] = "scroll";
    UpdateType["RESIZE"] = "resize";
    UpdateType["FORCED"] = "forced";
    UpdateType["FEATURE"] = "feature";
})(UpdateType || (UpdateType = {}));
var ScrollBehavior;
(function(ScrollBehavior) {
    ScrollBehavior["AUTO"] = "auto";
    ScrollBehavior["SMOOTH"] = "smooth";
})(ScrollBehavior || (ScrollBehavior = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"i3RlB"}],"i3RlB":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"awvb8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromCache", ()=>fromCache);
/**
 * Explicitly writes a value into the cache.
 * @typeParam T is the type of the value to cache
 * @param ref the reference
 * @param key the storage key
 * @param value the value
 */ parcelHelpers.export(exports, "writeCache", ()=>writeCache);
/**
 * Creates the cache entry by as specific key of a given reference.
 * @param ref the reference
 * @param key the storage key
 */ parcelHelpers.export(exports, "clearCache", ()=>clearCache);
/**
 * Clears the full cache by a given reference.
 * @param ref the reference.
 */ parcelHelpers.export(exports, "clearFullCache", ()=>clearFullCache);
parcelHelpers.export(exports, "cacheInstance", ()=>cacheInstance);
const __CACHE = new WeakMap();
function fromCache(ref, key, factory) {
    const storage = __CACHE.get(ref) || new Map();
    if (storage.has(key)) return storage.get(key);
    if (!factory) return undefined;
    const value = factory();
    storage.set(key, value);
    __CACHE.set(ref, storage);
    return value;
}
function writeCache(ref, key, value) {
    const storage = __CACHE.get(ref) || new Map();
    storage.set(key, value);
    __CACHE.set(ref, storage);
}
function clearCache(ref, key) {
    const storage = __CACHE.get(ref);
    if (!storage || !storage.has(key)) return;
    storage.delete(key);
}
function clearFullCache(ref) {
    __CACHE.delete(ref);
}
const cacheInstance = null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"i3RlB"}],"ei8Rc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Helper class for scrollbar features.
 * @internal
 */ parcelHelpers.export(exports, "Scrollbar", ()=>Scrollbar);
var _cache = require("../../utils/cache");
const CACHE_KEY_DIMENSIONS = 'dims';
class Scrollbar {
    /**
     * Creates an instance.
     * @internal
     */ constructor(){
        window.addEventListener('resize', ()=>{
            (0, _cache.clearCache)(this, CACHE_KEY_DIMENSIONS);
        });
    }
    /**
     * Calculates the dimensions of a scrollbar in the current browser. The result
     * of the computation will be cached for this instance.
     *
     * Inspired by https://gist.github.com/kflorence/3086552
     *
     * @return the dimensions of the scrollar
     */ get dimensions() {
        return (0, _cache.fromCache)(this, CACHE_KEY_DIMENSIONS, ()=>{
            const inner = document.createElement('div');
            const outer = document.createElement('div');
            document.body.appendChild(outer);
            outer.style.position = 'absolute';
            outer.style.top = '0px';
            outer.style.left = '0px';
            outer.style.visibility = 'hidden';
            outer.appendChild(inner);
            // Disabled, not needed for current feature set.
            //
            // Calculate width:
            // inner.style.width = '100%';
            // inner.style.height = '200px';
            // outer.style.width = '200px';
            // outer.style.height = '150px';
            // outer.style.overflow = 'hidden';
            // w1 = inner.offsetWidth;
            // outer.style.overflow = 'scroll';
            // w2 = inner.offsetWidth;
            // w2 = (w1 === w2) ? outer.clientWidth : w2;
            // width = w1 - w2;
            // Calculate height:
            inner.style.width = '200px';
            inner.style.height = '100%';
            outer.style.width = '150px';
            outer.style.height = '200px';
            outer.style.overflow = 'hidden';
            const h1 = inner.offsetHeight;
            outer.style.overflow = 'scroll';
            let h2 = inner.offsetHeight;
            h2 = h1 === h2 ? outer.clientHeight : h2;
            const height = h1 - h2;
            document.body.removeChild(outer);
            return {
                // width,
                height
            };
        });
    }
}

},{"../../utils/cache":"awvb8","@parcel/transformer-js/src/esmodule-helpers.js":"i3RlB"}],"cDUpB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A proxy instance between carousel and a feature. Restricts the access for
 * features to the carousel instance.
 */ parcelHelpers.export(exports, "Proxy", ()=>Proxy);
var _types = require("./types");
var _cache = require("./utils/cache");
const CACHE_KEY_INSTANCE = 'inst';
const CACHE_KEY_FEATURES = 'feat';
/**
 * Helper to access the instance cache.
 * @internal
 */ function __getInstance(ref) {
    return (0, _cache.fromCache)(ref, CACHE_KEY_INSTANCE);
}
/**
 * Helper to access the features cache.
 * @internal
 */ function __getFeatures(ref) {
    return (0, _cache.fromCache)(ref, CACHE_KEY_FEATURES);
}
class Proxy {
    /**
     * Creates an instance of the proxy.
     * @param instance the carousel instance to proxy the access to.
     * @param features all the features that should access the carousel through this instance.
     */ constructor(instance, features){
        (0, _cache.writeCache)(this, CACHE_KEY_INSTANCE, instance);
        (0, _cache.writeCache)(this, CACHE_KEY_FEATURES, features);
    }
    /**
     * Proxies the {@link Carousel.id | `id`} getter of the carousel.
     */ get id() {
        return __getInstance(this).id;
    }
    /**
     * Proxies the {@link Carousel.el | `el`} getter of the carousel.
     */ get el() {
        return __getInstance(this).el;
    }
    /**
     * Proxies the {@link Carousel.mask | `mask`} getter of the carousel.
     */ get mask() {
        return __getInstance(this).mask;
    }
    /**
     * Proxies the {@link Carousel.index | `index`} getter of the carousel.
     */ get index() {
        return __getInstance(this).index;
    }
    /**
     * Proxies the {@link Carousel.index | `index`} setter of the carousel.
     */ set index(value) {
        __getInstance(this).index = value;
    }
    /**
     * Proxies the {@link Carousel.items | `items`} getter of the carousel.
     */ get items() {
        return __getInstance(this).items;
    }
    /**
     * Proxies the {@link Carousel.pages | `pages`} getter of the carousel.
     */ get pages() {
        return __getInstance(this).pages;
    }
    /**
     * Proxies the {@link Carousel.pagesIndex | `pagesIndex`} getter of the carousel.
     */ get pageIndex() {
        return __getInstance(this).pageIndex;
    }
    /**
     * Function to trigger an update from a feature. This will send an update to
     * the carousel instance and all other attached features exept the sender.
     * @param sender feature that triggers the update.
     */ update(sender) {
        __getInstance(this).update();
        // Trigger update in all other features except the source feature that
        // triggered the event:
        __getFeatures(this).forEach((feature)=>{
            if (feature === sender) return;
            feature.update({
                type: (0, _types.UpdateType).FEATURE
            });
        });
    }
}

},{"./types":"cpTwZ","./utils/cache":"awvb8","@parcel/transformer-js/src/esmodule-helpers.js":"i3RlB"}],"kr3u0":[function(require,module,exports,__globalThis) {
// See: https://codeburst.io/throttling-and-debouncing-in-javascript-b01cad5c8edf
/**
 * Creates a debounced version for a given function in a given delay (in ms).
 * @typeParam F is the shape of the function to debounce.
 * @param func the original function
 * @param delay the delay in milliseconds (ms)
 * @returns the debounced function
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounce", ()=>debounce);
function debounce(func, delay) {
    let timeout = null;
    const debounced = (...args)=>{
        if (timeout !== null) clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), delay);
    };
    return debounced;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"i3RlB"}],"8zXO6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The feature to enable button controls (next and previous) for a carousel.
 */ parcelHelpers.export(exports, "Buttons", ()=>Buttons);
var _cache = require("../../utils/cache");
var _render = require("../../utils/render");
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const FEATURE_NAME = 'buildin:buttons';
const CACHE_KEY_PROXY = 'prxy';
const CACHE_KEY_CONFIGURATION = 'conf';
const CACHE_KEY_BUTTONS = 'btns';
const EVENT_CLICK = 'click';
const DEFAULTS = {
    template: ({ className, controls, label, title })=>`
		<button type="button" class="${className}" aria-label="${label}" title="${title}" aria-controls="${controls}">
			<span>${label}</span>
		</button>
	`,
    className: 'button',
    nextClassName: 'is-next',
    nextLabel: 'Next',
    nextTitle: 'Go to next',
    previousClassName: 'is-previous',
    previousLabel: 'Previous',
    previousTitle: 'Go to previous'
};
class Buttons {
    /**
     * Creates an instance of this feature.
     * @param options are the options to configure this instance
     */ constructor(options = {}){
        (0, _cache.writeCache)(this, CACHE_KEY_CONFIGURATION, Object.assign(Object.assign({}, DEFAULTS), options));
        this._onPrev = this._onPrev.bind(this);
        this._onNext = this._onNext.bind(this);
    }
    /**
     * Returns the name of this feature.
     */ get name() {
        return FEATURE_NAME;
    }
    /**
     * Initializes this feature. This function will be called by the carousel
     * instance and should not be called manually.
     * @internal
     * @param proxy the proxy instance between carousel and feature
     */ init(proxy) {
        (0, _cache.writeCache)(this, CACHE_KEY_PROXY, proxy);
        this._render();
    }
    /**
     * Destroys this feature. This function will be called by the carousel instance
     * and should not be called manually.
     * @internal
     */ destroy() {
        this._remove();
        (0, _cache.clearFullCache)(this);
    }
    /**
     * This triggers the feature to update its inner state. This function will be
     * called by the carousel instance and should not be called manually. The
     * carousel passes a event object that includes the update reason. This can be
     * used to selectively/partially update sections of the feature.
     * @internal
     */ update() {
        this._render();
    }
    /**
     * Renders and update the button elements. Buttons will only be rendered once
     * and then loaded from cache. When calling this function twice or more, the
     * button states will be updated based on the scroll position.
     * @internal
     */ _render() {
        const proxy = (0, _cache.fromCache)(this, CACHE_KEY_PROXY);
        const config = (0, _cache.fromCache)(this, CACHE_KEY_CONFIGURATION);
        const { el, mask, pages, pageIndex } = proxy;
        // Render buttons only once. Load them from cache if already rendered and
        // attached to the dom:
        const [next, previous] = (0, _cache.fromCache)(this, CACHE_KEY_BUTTONS, ()=>{
            const target = mask !== null && mask !== void 0 ? mask : el;
            const { template, className, previousClassName, previousLabel, previousTitle, nextClassName, nextLabel, nextTitle } = config;
            // Create button elements:
            const settings = [
                {
                    controls: el.id,
                    label: nextLabel,
                    title: nextTitle,
                    className: [
                        className,
                        nextClassName
                    ].join(' '),
                    // The onClick listener is already bound in the constructor.
                    //
                    // eslint-disable-next-line @typescript-eslint/unbound-method
                    handler: this._onNext
                },
                {
                    controls: el.id,
                    label: previousLabel,
                    title: previousTitle,
                    className: [
                        className,
                        previousClassName
                    ].join(' '),
                    // The onClick listener is already bound in the constructor.
                    //
                    // eslint-disable-next-line @typescript-eslint/unbound-method
                    handler: this._onPrev
                }
            ];
            return settings.map((_a)=>{
                var _b;
                var { handler } = _a, params = __rest(_a, [
                    "handler"
                ]);
                const button = (0, _render.render)(template, params);
                if (!button) return null;
                button.addEventListener(EVENT_CLICK, handler);
                (_b = target.parentNode) === null || _b === void 0 || _b.insertBefore(button, target.nextSibling);
                return button;
            });
        });
        if (next) {
            const lastPage = pages[pageIndex + 1];
            const isLastPage = lastPage === undefined;
            next.disabled = isLastPage;
        }
        if (previous) {
            const firstPage = pages[pageIndex - 1];
            const isFirstPage = firstPage === undefined;
            previous.disabled = isFirstPage;
        }
    }
    /**
     * Removes all buttons from the dom and detaches all event handler.
     * @internal
     */ _remove() {
        const buttons = (0, _cache.fromCache)(this, CACHE_KEY_BUTTONS);
        buttons === null || buttons === void 0 || buttons.forEach((button)=>{
            var _a;
            // The onClick listener is already bound in the constructor.
            //
            // eslint-disable-next-line @typescript-eslint/unbound-method
            button === null || button === void 0 || button.removeEventListener(EVENT_CLICK, this._onPrev);
            // The onClick listener is already bound in the constructor.
            //
            // eslint-disable-next-line @typescript-eslint/unbound-method
            button === null || button === void 0 || button.removeEventListener(EVENT_CLICK, this._onNext);
            (_a = button === null || button === void 0 ? void 0 : button.parentNode) === null || _a === void 0 || _a.removeChild(button);
        });
    }
    /**
     * Event handler to navigate backwards (to the left).
     * @internal
     */ _onPrev() {
        const proxy = (0, _cache.fromCache)(this, CACHE_KEY_PROXY);
        const { pages, pageIndex } = proxy;
        const index = pages[pageIndex - 1] || pages[0];
        proxy.index = index;
    }
    /**
     * Event handler to navigate forwards (to the right).
     * @internal
     */ _onNext() {
        const proxy = (0, _cache.fromCache)(this, CACHE_KEY_PROXY);
        const { pages, pageIndex } = proxy;
        const index = pages[pageIndex + 1] || pages[pages.length - 1];
        proxy.index = index;
    }
}

},{"../../utils/cache":"awvb8","../../utils/render":"484ss","@parcel/transformer-js/src/esmodule-helpers.js":"i3RlB"}],"484ss":[function(require,module,exports,__globalThis) {
/**
 * Renders a template (function) to into an HTML element. The template needs to
 * return a valid HTML string (with a single root element). A context with
 * key/value pairs will be passed into the template to allow dynamic rendering.
 * @typeParam El is the type of the rendered dom element.
 * @typeParam Context is the shape of the context data object
 * @param template a function to render a template
 * @param context context data for the template
 * @returns the rendered htmml element
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
function render(template, context) {
    const el = document.createElement('div');
    el.innerHTML = template(context);
    const ref = el.firstElementChild;
    if (!ref) return null;
    return ref;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"i3RlB"}],"880s8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Feature to enable mouse controls
 */ parcelHelpers.export(exports, "Mouse", ()=>Mouse);
var _cache = require("../../utils/cache");
const FEATURE_NAME = 'buildin:mouse';
const CACHE_KEY_PROXY = 'prxy';
const CACHE_KEY_CONFIGURATION = 'conf';
const CACHE_KEY_PAGE_INDEX = 'pgidx';
const CACHE_KEY_POSITION_X = 'posx';
const CACHE_KEY_SCROLL_LEFT = 'scrl';
const CACHE_KEY_TIMEOUT = 'time';
const CURSOR_GRAB = 'grab';
const CURSOR_GRABBING = 'grabbing';
const EVENT_START = 'mousedown';
const EVENT_DRAG = 'mousemove';
const EVENT_END = 'mouseup';
const THRESHOLD_MIN = 100;
const THRESHOLD_MAX = 250;
const THRESHOLD_FACTOR = 0.25; // Relative carousel element width
// We are ignoring this due to this whole feature is only here to make TS happy.
/* istanbul ignore next */ /**
 * Extracts the client x position from an event depending on the event type.
 * @internal
 * @param event the event
 * @returns the client x position
 */ function __getPositionX(event) {
    if (event instanceof MouseEvent) return event.clientX;
    return 0;
}
const DEFAULTS = {
    indicator: false
};
class Mouse {
    /**
     * Creates an instance of this feature.
     * @param options are the options to configure this instance
     */ constructor(options = {}){
        (0, _cache.writeCache)(this, CACHE_KEY_CONFIGURATION, Object.assign(Object.assign({}, DEFAULTS), options));
        this._onStart = this._onStart.bind(this);
        this._onDrag = this._onDrag.bind(this);
        this._onEnd = this._onEnd.bind(this);
    }
    /**
     * Returns the name of this feature.
     */ get name() {
        return FEATURE_NAME;
    }
    /**
     * Initializes this feature. This function will be called by the carousel
     * instance and should not be called manually.
     * @internal
     * @param proxy the proxy instance between carousel and feature
     */ init(proxy) {
        (0, _cache.writeCache)(this, CACHE_KEY_PROXY, proxy);
        const config = (0, _cache.fromCache)(this, CACHE_KEY_CONFIGURATION);
        const { el } = proxy;
        const element = el;
        element.style.cursor = config.indicator ? CURSOR_GRAB : '';
        // The handler is already bound in the constructor.
        //
        // eslint-disable-next-line @typescript-eslint/unbound-method
        el.addEventListener(EVENT_START, this._onStart, {
            passive: true
        });
    }
    /**
     * Destroys this feature. This function will be called by the carousel instance
     * and should not be called manually.
     * @internal
     */ destroy() {
        (0, _cache.clearFullCache)(this);
    }
    /**
     * This triggers the feature to update its inner state. This function will be
     * called by the carousel instance and should not be called manually. The
     * carousel passes a event object that includes the update reason. This can be
     * used to selectively/partially update sections of the feature.
     * @internal
     */ update() {
    /* nothing to update yet */ }
    /**
     * Handles the drag start event.
     * @internal
     * @param event the event that triggered the drag start
     */ _onStart(event) {
        var _a;
        const timeout = (0, _cache.fromCache)(this, CACHE_KEY_TIMEOUT);
        clearTimeout(timeout);
        const config = (0, _cache.fromCache)(this, CACHE_KEY_CONFIGURATION);
        const proxy = (0, _cache.fromCache)(this, CACHE_KEY_PROXY);
        const element = proxy.el;
        (0, _cache.fromCache)(this, CACHE_KEY_SCROLL_LEFT, ()=>element.scrollLeft);
        (0, _cache.fromCache)(this, CACHE_KEY_POSITION_X, ()=>__getPositionX(event));
        (0, _cache.fromCache)(this, CACHE_KEY_PAGE_INDEX, ()=>proxy.pageIndex);
        // Reset scroll behavior and scroll snapping to emulate regular scrolling.
        // Prevent user selection while the user drags:
        element.style.userSelect = 'none';
        element.style.scrollBehavior = 'auto';
        element.style.scrollSnapType = 'none';
        element.style.cursor = config.indicator ? CURSOR_GRABBING : '';
        // The handlers are already bound in the constructor.
        //
        /* eslint-disable @typescript-eslint/unbound-method */ window.addEventListener(EVENT_DRAG, this._onDrag, {
            passive: true
        });
        window.addEventListener(EVENT_END, this._onEnd, {
            passive: true
        });
        /* eslint-enable @typescript-eslint/unbound-method */ // Call the hook:
        (_a = config.onStart) === null || _a === void 0 || _a.call(config, {
            originalEvent: event
        });
    }
    /**
     * Handles the drag event. Calculates and updates scroll position.
     * @internal
     * @param event the event that triggered the dragging
     */ _onDrag(event) {
        var _a, _b, _c;
        const config = (0, _cache.fromCache)(this, CACHE_KEY_CONFIGURATION);
        const { el } = (0, _cache.fromCache)(this, CACHE_KEY_PROXY);
        const left = (_a = (0, _cache.fromCache)(this, CACHE_KEY_SCROLL_LEFT)) !== null && _a !== void 0 ? _a : 0;
        const x = (_b = (0, _cache.fromCache)(this, CACHE_KEY_POSITION_X)) !== null && _b !== void 0 ? _b : 0;
        const currentX = __getPositionX(event);
        const deltaX = x - currentX;
        el.scrollLeft = left + deltaX;
        // Call the hook:
        (_c = config.onDrag) === null || _c === void 0 || _c.call(config, {
            originalEvent: event
        });
    }
    /**
     * Handles the drag end event.
     * @internal
     * @param event the event that triggered the drag end
     */ _onEnd(event) {
        var _a, _b, _c, _d;
        const proxy = (0, _cache.fromCache)(this, CACHE_KEY_PROXY);
        const config = (0, _cache.fromCache)(this, CACHE_KEY_CONFIGURATION);
        const left = (_a = (0, _cache.fromCache)(this, CACHE_KEY_SCROLL_LEFT)) !== null && _a !== void 0 ? _a : 0;
        const pageIndex = (_b = (0, _cache.fromCache)(this, CACHE_KEY_PAGE_INDEX)) !== null && _b !== void 0 ? _b : 0;
        (0, _cache.clearCache)(this, CACHE_KEY_SCROLL_LEFT);
        (0, _cache.clearCache)(this, CACHE_KEY_POSITION_X);
        (0, _cache.clearCache)(this, CACHE_KEY_PAGE_INDEX);
        const element = proxy.el;
        const threshold = Math.min(Math.max(THRESHOLD_MIN, element.clientWidth * THRESHOLD_FACTOR), THRESHOLD_MAX);
        const currentLeft = element.scrollLeft;
        const distance = currentLeft - left;
        const offset = Math.abs(distance);
        element.style.removeProperty('user-select');
        element.style.removeProperty('scroll-behavior');
        element.style.cursor = config.indicator ? CURSOR_GRAB : '';
        // Apply the index. If the scroll offset is higher that the threshold,
        // navigate to the next page depending on the drag direction.
        let index = proxy.index;
        if (offset > threshold) {
            const direction = distance / offset;
            const at = Math.max(pageIndex + direction, 0);
            index = (_c = proxy.pages[at]) !== null && _c !== void 0 ? _c : index;
        }
        // Apply the index until the styles are rendered to the element. This is
        // required to have a smooth scroll-behaviour which is disabled during the
        // mouse dragging.
        window.requestAnimationFrame(()=>{
            proxy.index = index;
        });
        // Get around the scroll-snapping. Enable it until the position is already
        // applied. This will take ~1000ms depending on distance and browser
        // behaviour.
        const timeout = window.setTimeout(()=>{
            element.style.removeProperty('scroll-snap-type');
        }, 1000);
        (0, _cache.writeCache)(this, CACHE_KEY_TIMEOUT, timeout);
        // The handlers are already bound in the constructor.
        //
        /* eslint-disable @typescript-eslint/unbound-method */ window.removeEventListener(EVENT_DRAG, this._onDrag);
        window.removeEventListener(EVENT_END, this._onEnd);
        /* eslint-enable @typescript-eslint/unbound-method */ // Call the hook:
        (_d = config.onEnd) === null || _d === void 0 || _d.call(config, {
            originalEvent: event
        });
    }
}

},{"../../utils/cache":"awvb8","@parcel/transformer-js/src/esmodule-helpers.js":"i3RlB"}],"206hL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The feature to enable pagination controls.
 */ parcelHelpers.export(exports, "Pagination", ()=>Pagination);
var _types = require("../../types");
var _cache = require("../../utils/cache");
var _render = require("../../utils/render");
const FEATURE_NAME = 'buildin:pagination';
const CACHE_KEY_PROXY = 'prxy';
const CACHE_KEY_CONFIGURATION = 'conf';
const CACHE_KEY_PAGINATION = 'pags';
const CACHE_KEY_BUTTONS = 'btns';
const DEFAULTS = {
    // @TODO: ESLint don't like the nested template literals and loops.
    /* eslint-disable indent */ template: ({ className, controls, pages, label, title })=>`
		<ul class="${className}">
			${pages.map((page, index)=>{
            const data = {
                index,
                page,
                pages
            };
            const labelStr = label(data);
            const titleStr = title(data);
            return `<li>
					<button type="button" aria-controls="${controls}" aria-label="${titleStr}" title="${titleStr}">
						<span>${labelStr}</span>
					</button>
				</li>`;
        }).join('')}
		</ul>
	`,
    /* eslint-enable indent */ className: 'pagination',
    label: ({ index })=>`${index + 1}`,
    title: ({ index })=>`Go to ${index + 1}. page`
};
class Pagination {
    /**
     * Creates an instance of this feature.
     * @param options are the options to configure this instance
     */ constructor(options = {}){
        (0, _cache.writeCache)(this, CACHE_KEY_CONFIGURATION, Object.assign(Object.assign({}, DEFAULTS), options));
        this._onClick = this._onClick.bind(this);
    }
    /**
     * Returns the name of this feature.
     */ get name() {
        return FEATURE_NAME;
    }
    /**
     * Initializes this feature. This function will be called by the carousel
     * instance and should not be called manually.
     * @internal
     * @param proxy the proxy instance between carousel and feature
     */ init(proxy) {
        (0, _cache.writeCache)(this, CACHE_KEY_PROXY, proxy);
        this._add();
    }
    /**
     * Destroys this feature. This function will be called by the carousel instance
     * and should not be called manually.
     * @internal
     */ destroy() {
        this._remove();
        (0, _cache.clearFullCache)(this);
    }
    /**
     * This triggers the feature to update its inner state. This function will be
     * called by the carousel instance and should not be called manually. The
     * carousel passes a event object that includes the update reason. This can be
     * used to selectively/partially update sections of the feature.
     * @internal
     * @param event event that triggered the update
     * @param event.type is the update reason (why this was triggered)
     */ update(event) {
        switch(event.type){
            case (0, _types.UpdateType).SCROLL:
                this._update();
                break;
            default:
                this._remove();
                this._add();
                break;
        }
    }
    /**
     * Renders and adds the pagination element. Attaches event handlers to all
     * button elements.
     * @internal
     */ _add() {
        var _a;
        const proxy = (0, _cache.fromCache)(this, CACHE_KEY_PROXY);
        const config = (0, _cache.fromCache)(this, CACHE_KEY_CONFIGURATION);
        const { el, mask, pages } = proxy;
        const target = mask !== null && mask !== void 0 ? mask : el;
        if (pages.length < 2) return;
        const { template, className, label, title } = config;
        const pagination = (0, _render.render)(template, {
            label,
            title,
            pages,
            className,
            controls: el.id
        });
        if (!pagination) return;
        // @TODO: Add template for buttons:
        const buttons = Array.from(pagination.querySelectorAll('button')).map((button)=>{
            // The onClick listener is already bound in the constructor.
            //
            // eslint-disable-next-line @typescript-eslint/unbound-method
            button.addEventListener('click', this._onClick, true);
            return button;
        });
        (_a = target.parentNode) === null || _a === void 0 || _a.appendChild(pagination);
        (0, _cache.writeCache)(this, CACHE_KEY_PAGINATION, pagination);
        (0, _cache.writeCache)(this, CACHE_KEY_BUTTONS, buttons);
        this._update();
    }
    /**
     * Updates the states of all buttons inside the pagination.
     * @internal
     */ _update() {
        const proxy = (0, _cache.fromCache)(this, CACHE_KEY_PROXY);
        const buttons = (0, _cache.fromCache)(this, CACHE_KEY_BUTTONS);
        const { pageIndex } = proxy;
        buttons === null || buttons === void 0 || buttons.forEach((button, at)=>button.disabled = at === pageIndex);
    }
    /**
     * Removes the whole pagination element and removes all attached event handlers.
     * @internal
     */ _remove() {
        var _a;
        const pagination = (0, _cache.fromCache)(this, CACHE_KEY_PAGINATION);
        const buttons = (0, _cache.fromCache)(this, CACHE_KEY_BUTTONS);
        buttons === null || buttons === void 0 || buttons.forEach((button)=>{
            var _a;
            // The onClick listener is already bound in the constructor.
            //
            // eslint-disable-next-line @typescript-eslint/unbound-method
            button.removeEventListener('click', this._onClick);
            (_a = button.parentNode) === null || _a === void 0 || _a.removeChild(button);
        });
        (_a = pagination === null || pagination === void 0 ? void 0 : pagination.parentNode) === null || _a === void 0 || _a.removeChild(pagination);
        (0, _cache.clearCache)(this, CACHE_KEY_BUTTONS);
        (0, _cache.clearCache)(this, CACHE_KEY_PAGINATION);
    }
    /**
     * Event handler when a button is clicked. Detects the current index of the
     * clicked button inside the pagination and updates the index accordingly of
     * the carousel.
     * @internal
     * @param event the mouse event
     */ _onClick(event) {
        const proxy = (0, _cache.fromCache)(this, CACHE_KEY_PROXY);
        const buttons = (0, _cache.fromCache)(this, CACHE_KEY_BUTTONS);
        if (!buttons) return;
        const target = event.currentTarget;
        const index = buttons.indexOf(target);
        proxy.index = proxy.pages[index];
    }
}

},{"../../types":"cpTwZ","../../utils/cache":"awvb8","../../utils/render":"484ss","@parcel/transformer-js/src/esmodule-helpers.js":"i3RlB"}]},[], null, "parcelRequireec03", {})

//# sourceMappingURL=web.f063a71a.js.map
